import { HereLayer } from 'common/utils/MapMarker/types';
import { useMemo } from 'react';
import {
  useNavigationHistoryPath,
  useNavigationHistoryPathCoordinatesByIdex
} from 'entities/navigation';

import { NavigationHistoryPath } from 'entities/navigation';
import { point } from '@turf/helpers';
import { bearing } from '@turf/bearing';

const getIcon = (deg: number) => `<svg width="36" height="36" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" >
    <g filter="url(#filter0_d_2221_105243)">
    <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" fill="#4E5864" />
    <path d="M21.5 12C21.5 17.2467 17.2467 21.5 12 21.5C6.75329 21.5 2.5 17.2467 2.5 12C2.5 6.75329 6.75329 2.5 12 2.5C17.2467 2.5 21.5 6.75329 21.5 12Z" stroke="#3B424B" stroke-linecap="round" stroke-linejoin="round"/>
    </g>
    <path d="M12.0007 6.3252L7.44727 15.9684L7.87833 16.3428L12.0007 14.7611L16.1231 16.3428L16.5542 15.9684L12.0007 6.3252Z" fill="white" transform="rotate(${deg}, 12, 12)"/>
    <defs>
    <filter id="filter0_d_2221_105243" x="0.5" y="1" width="23" height="23" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
    <feOffset dy="0.5"/>
    <feGaussianBlur stdDeviation="0.75"/>
    <feComposite in2="hardAlpha" operator="out"/>
    <feColorMatrix type="matrix" values="0 0 0 0 0.105882 0 0 0 0 0.121569 0 0 0 0 0.137255 0 0 0 0.24 0"/>
    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2221_105243"/>
    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2221_105243" result="shape"/>
    </filter>
    </defs>
  </svg>`;

export const useCarMovingMarkerLayout = (carPointIndex?: number) => {
  const historyPath = useNavigationHistoryPath();
  const navigationHistoryPathCoordinatesByIdex = useNavigationHistoryPathCoordinatesByIdex(carPointIndex);

  let degrees = 0;

  if (historyPath && carPointIndex) {
    const currentPoint = historyPath[carPointIndex];
    const nextPoint = historyPath[carPointIndex + 1];
    if (!currentPoint?.locations[0] || !nextPoint?.locations[0]) {
      degrees = 0;
    } else {
      const pointS = point([currentPoint.locations[0].longitude, currentPoint.locations[0].latitude]);
      const pointF = point([nextPoint.locations[0].longitude, nextPoint.locations[0].latitude]);
      degrees = bearing(pointS, pointF);
    }
  }

  const clientHistoryEventsMarkersLayer = useMemo(
    (): HereLayer => ({
      data: navigationHistoryPathCoordinatesByIdex ? [navigationHistoryPathCoordinatesByIdex] : [],
      name: 'history-car-moving-point',
      type: 'native-marker',
      getCoordinates: ({ data } : { data: NavigationHistoryPath }) => {
        const [point] = data.locations || [];
        const { latitude, longitude } = point;
        return { latitude, longitude, altitude: 0 };
      },
      getIcon: () => ({
        url: getIcon(degrees),
        height: 72,
        width: 72,
        anchorY: 72,
        anchorX: 36,
        id: 'history-car-moving-point'
      })
    }),
    [navigationHistoryPathCoordinatesByIdex, degrees]
  );

  return clientHistoryEventsMarkersLayer;
};
